module.exports = __webpack_public_path__ + "static/media/BTECH_EXTC_2022-2026_Scheme_modified.bb1ebe16.pdf";